import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD,
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD_BY_ID,
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD_FAILURE,
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD_SUCCESS,

    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_SAVE,
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_SAVE_SUCCESS,
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_SAVE_FAILURE,

    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CREATE,
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CREATE_SUCCESS,
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CREATE_FAILURE,

    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_VALIDATE,
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_VALIDATE_SUCCESS,
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_VALIDATE_FAILURE,

    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CLEAR,
    ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_FILTER,

    TrialInstitutionItemTemplateCategoryAction
} from '../actions/trialInstitutionItemTemplateCategories';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface ITrialInstitutionItemTemplateCategoryState {
    formData: Dtos.TrialInstitutionItemTemplateCategory | Dtos.TrialInstitutionItemTemplateCategory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[];
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    validateState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.TrialInstitutionItemTemplateCategory[];
}

const initialState: ITrialInstitutionItemTemplateCategoryState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: []
};


function loading(state: ITrialInstitutionItemTemplateCategoryState, _isLoading: boolean): ITrialInstitutionItemTemplateCategoryState {
    const newState: ITrialInstitutionItemTemplateCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: ITrialInstitutionItemTemplateCategoryState,
    formData: Dtos.TrialInstitutionItemTemplateCategory | Dtos.TrialInstitutionItemTemplateCategory[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionItemTemplateCategoryState {
    const newState: ITrialInstitutionItemTemplateCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: ITrialInstitutionItemTemplateCategoryState, formFilter: IFormFilter): ITrialInstitutionItemTemplateCategoryState {

    const trialInstitutionItemTemplateCategories: Dtos.TrialInstitutionItemTemplateCategory[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formFilteredData = trialInstitutionItemTemplateCategories ? trialInstitutionItemTemplateCategories.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || p.value.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: ITrialInstitutionItemTemplateCategoryState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        }
    });

    return newState;
}

function loadFailure(state: ITrialInstitutionItemTemplateCategoryState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemTemplateCategoryState {
    const newState: ITrialInstitutionItemTemplateCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: ITrialInstitutionItemTemplateCategoryState, propertiesToClear?: string[]): ITrialInstitutionItemTemplateCategoryState {

    if (!propertiesToClear) {
        let formFilter = state.formFilter;
        const newState: ITrialInstitutionItemTemplateCategoryState = update(initialState, {
            formFilter: {
                $set: formFilter
            }
        });
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: ITrialInstitutionItemTemplateCategoryState, _isSaving: boolean): ITrialInstitutionItemTemplateCategoryState {
    const newState: ITrialInstitutionItemTemplateCategoryState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: ITrialInstitutionItemTemplateCategoryState,
    formData: Dtos.TrialInstitutionItemTemplateCategory | Dtos.TrialInstitutionItemTemplateCategory[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionItemTemplateCategoryState {
    const newState: ITrialInstitutionItemTemplateCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: ITrialInstitutionItemTemplateCategoryState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemTemplateCategoryState {
    const newState: ITrialInstitutionItemTemplateCategoryState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: ITrialInstitutionItemTemplateCategoryState, _isCreating: boolean): ITrialInstitutionItemTemplateCategoryState {
    const newState: ITrialInstitutionItemTemplateCategoryState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: ITrialInstitutionItemTemplateCategoryState,
    formData: Dtos.TrialInstitutionItemTemplateCategory,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): ITrialInstitutionItemTemplateCategoryState {
    const newState: ITrialInstitutionItemTemplateCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: ITrialInstitutionItemTemplateCategoryState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemTemplateCategoryState {
    const newState: ITrialInstitutionItemTemplateCategoryState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function validating(state: ITrialInstitutionItemTemplateCategoryState, _isValidating: boolean): ITrialInstitutionItemTemplateCategoryState {
    const newState: ITrialInstitutionItemTemplateCategoryState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: ITrialInstitutionItemTemplateCategoryState,
    formData: Dtos.TrialInstitutionItemTemplateCategory,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionItemTemplateCategoryState {
    const newState: ITrialInstitutionItemTemplateCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: ITrialInstitutionItemTemplateCategoryState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemTemplateCategoryState {
    const newState: ITrialInstitutionItemTemplateCategoryState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

const TrialInstitutionItemTemplateCategoryReducer: Reducer<ITrialInstitutionItemTemplateCategoryState> = (state: ITrialInstitutionItemTemplateCategoryState = initialState, action: TrialInstitutionItemTemplateCategoryAction) => {
    switch (action.type) {
        case ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD:
        case ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_SAVE:
            return saving(state, true);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CREATE:
            return creating(state, true);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_VALIDATE:
            return validating(state, true);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEMTEMPLATECATEGORIES_FILTER:
            return filter(state, action.formFilter);

    }

    return state;
}

export default TrialInstitutionItemTemplateCategoryReducer;